import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RsvpStore } from '../service/rsvp.store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { Rsvp } from '../models/rsvp';

@Injectable()
export class RsvpListResolver implements Resolve<any> {
  constructor(private rsvpStore: RsvpStore,
              private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<Rsvp>> {
    const id = route.params[ 'id' ];
    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_RSVPS'));
    }

    return this.rsvpStore.loadRsvps(route.params[ 'id' ]).first();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/rsvp-list/rsvp-list.resolver.ts